import moment from "moment"
import { Flex } from "@chakra-ui/react"
import { NORMALIZED_CHANGE_ITEM_TYPE } from "types/laundry"
import { IChangeListItemProps } from "./ChangeListItemTypes"

import ChangeListItemText from "./ChangeListItemText"
import ChangeListItemImage from "./ChangeListItemImage"
import ChangeListItemLocation from "./ChangeListItemLocation"
import ChangeListItemWashType from "./ChangeListItemWashType"
import ChangeListItemAdditionalService from "./ChangeListItemAdditionalService"

const ChangeListItem: React.FC<IChangeListItemProps> = ({ title, value, type, typeId, isCurrent }) => {

  const generateTextValue = (value: string, typeId: number) => {
    if (typeId === 4) {
      return `${moment(value).format("HH:mm")}`
    }

    return value
  }

  return (
    <Flex marginBottom={"16px"} w={"fit-content"} flexDirection={"column"}>
      {type === NORMALIZED_CHANGE_ITEM_TYPE.TEXT && <ChangeListItemText title={title} value={generateTextValue(value, typeId)} />}
      {type === NORMALIZED_CHANGE_ITEM_TYPE.IMG && <ChangeListItemImage title={title} imageUrl={value} />}
      {type === NORMALIZED_CHANGE_ITEM_TYPE.LOCATION &&
        <ChangeListItemLocation
          title={title}
          lat={value.split(" ")[0]}
          lng={value.split(" ")[1]}
          isCurrent={isCurrent}
        />
      }
      {type === NORMALIZED_CHANGE_ITEM_TYPE.WASH_TYPE && <ChangeListItemWashType title={title} value={value} />}
      {type === NORMALIZED_CHANGE_ITEM_TYPE.ADDITIONAL_SERVICE && <ChangeListItemAdditionalService title={title} value={value} />}
    </Flex>
  )
}

export default ChangeListItem